import { Radio } from 'antd';
import styled from 'styled-components';

export const Title = styled.h3<{ $isMobile?: boolean }>`
	font-size: 16px;
	font-weight: 600;
	line-height: 24px;
	margin-bottom: 10px;
	color: ${({ $isMobile }) => ($isMobile ? '#000' : '#595959')};
`;

export const ToggleSchool = styled.button<{ $isMobile: boolean }>`
	display: flex;
	gap: 10px;
	align-items: center;

	justify-content: ${({ $isMobile }) => ($isMobile ? 'space-between' : 'flex-start')};
	width: ${({ $isMobile }) => ($isMobile ? '100%' : 'auto')};

	font-size: 16px;

	white-space: nowrap;

	color: #262626;

	border: none;
	background: none;
	outline: none;

	cursor: pointer;
`;

export const Arrows = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;

	img {
		width: 9px;
		height: 8px;

		&:last-of-type {
			rotate: 180deg;
		}
	}
`;

export const DropdownContent = styled.div`
	background-color: #fff;
	border-radius: 8px;

	border: 1px solid #d9d9d9;
	box-shadow: 0px 4px 6px 0px #0000001a;

	padding: 18px 12px;
`;

export const RadioGroup = styled(Radio.Group)`
	display: flex;
	flex-direction: column;
`;

export const RadioStyled = styled(Radio)`
	padding: 15px 10px;

	border-bottom: 1px solid #f0f0f0;

	&:last-of-type {
		border-bottom: none;
	}
`;
